import BackgroundIcon from "@/assets/icons/background.svg";
import BulbIcon from "@/assets/icons/bulb.svg";
import FlagIcon from "@/assets/icons/flag.svg";
import GridDotBlank from "@/assets/icons/grid-dots-blank.svg?url";
import HeartIcon from "@/assets/icons/heart.svg";
import LeftArrow from "@/assets/icons/left-arrow.svg";
import LeftCenterIcon from "@/assets/icons/left-center.svg";
import LeftFixedIcon from "@/assets/icons/left-fixed.svg";
import RightArrow from "@/assets/icons/right-arrow.svg";
import RightCenterIcon from "@/assets/icons/right-center.svg";
import RightFixedIcon from "@/assets/icons/right-fixed.svg";
import StarIcon from "@/assets/icons/star.svg";
import ThumbsUpIcon from "@/assets/icons/thumbsup.svg";
import TopArrow from "@/assets/icons/top-arrow.svg";
import TopFixedIcon from "@/assets/icons/top-fixed.svg";
import PercentageBarSelectedImage from "@/assets/img/percentage-bar-selected.png";
import PercentageBarImage from "@/assets/img/percentage-bar.png";
import StepsSelectedImage from "@/assets/img/steps-selected.png";
import StepsImage from "@/assets/img/steps.png";
import {
  AlignVerticalCenter01Icon,
  Maximize02Icon,
  Monitor04Icon,
  Phone01Icon,
  SlashCircle01Icon,
  SquareIcon,
} from "@gohighlevel/ghl-icons/24/outline";
import { CarouselItem } from "@gohighlevel/ghl-ui/dist/types/components/carousel";
import { h } from "vue";
import { i18n } from "../plugin/vue-i18n";
const { t } = i18n.global;

// Embedded forms
export const STICKY_SIDEBAR = "STICKY_SIDEBAR";
export const POLITE_SLIDE_IN = "POLITE_SLIDE_IN";
export const POPUP = "POPUP";
export const INLINE = "INLINE";
// FORM LAYOUTS URLs
export const FORM_LAYOUT_URLS = {
  STICKY_SIDEBAR: "https://stcdn.leadconnectorhq.com/forms/img/sticky-sidebar.png",
  POLITE_SLIDE_IN: "https://stcdn.leadconnectorhq.com/forms/img/polite-slide-in.png",
  STICKY_SIDEBAR_RIGHT: "https://stcdn.leadconnectorhq.com/forms/img/polite-slide-in-right.png",
  POLITE_SLIDE_IN_LEFT: "https://stcdn.leadconnectorhq.com/forms/img/sticky-sidebar-left.png",
  POPUP: "https://stcdn.leadconnectorhq.com/forms/img/popup-layout.png",
  INLINE: "https://stcdn.leadconnectorhq.com/forms/img/inline-layout.png",
};
export const CARD_LAYOUTS = [
  {
    id: "STICKY_SIDEBAR",
    image: FORM_LAYOUT_URLS.STICKY_SIDEBAR,
    name: `${t("form.stickySidebar")}`,
    allowMinimize: false,
    minimizedTitle: "",
    isLeftAligned: true,
    isRightAligned: false,
    description: `${t("form.stickySidebarDescription")}`,
    hoverDescription: `${t("form.stickySidebarHoverDescription")}`,
    class: "items-end gap-2 px-[1px] pb-3 pt-6",
    iconClass: "w-[20px] h-[32px]",
  },
  {
    id: "POLITE_SLIDE_IN",
    image: FORM_LAYOUT_URLS.POLITE_SLIDE_IN,
    name: `${t("form.politeSlideIn")}`,
    allowMinimize: false,
    minimizedTitle: "",
    isLeftAligned: false,
    isRightAligned: true,
    description: `${t("form.politeSlideInDescription")}`,
    hoverDescription: `${t("form.politeSlideInHoverDescription")}`,
    class: "items-end gap-2 px-[9px] pb-3 pt-6",
    iconClass: "w-[20px] h-[32px]",
  },
  {
    id: "POPUP",
    image: FORM_LAYOUT_URLS.POPUP,
    name: `${t("form.popup")}`,
    description: `${t("form.popupDescription")}`,
    hoverDescription: `${t("form.politeSlideInHoverDescription")}`,
    class: "items-center justify-center gap-2 px-[9px] !bg-[#F3F4F7]",
    iconClass: "w-[32px] h-[32px]",
  },
  {
    id: "INLINE",
    image: FORM_LAYOUT_URLS.INLINE,
    name: `${t("form.inline")}`,
    description: `${t("form.inlineDescription")}`,
    hoverDescription: `${t("form.inlineHoverDescription")}`,
    class: "items-center justify-center gap-2 px-[9px]",
    iconClass: "w-[32px] h-[32px]",
  },
];

export const TRIGGERS = [
  { id: "showOnScrolling", name: `${t("form.showOnScrolling")}`, showInput: true },
  { id: "showAfter", name: `${t("form.showAfter")}`, showInput: true },
  { id: "alwaysShow", name: `${t("form.alwaysShow")}`, showInput: false },
];

export const ACTIVATION_OPTIONS = [
  { id: "activateOnVisit", name: `${t("form.activateOn")}`, showInput: true },
  { id: "alwaysActivated", name: `${t("form.alwaysActivated")}`, showInput: false },
];

export const DEACTIVATION_OPTIONS = [
  {
    id: "deactivateAfter",
    name: `${t("form.deactivateAfterShowing")}`,
    showInput: true,
  },
  {
    id: "leadCollected",
    name: `${t("form.deactiveOnceLeadCollected")}`,
    showInput: false,
  },
  { id: "neverDeactivate", name: `${t("form.neverDeactivate")}`, showInput: false },
];

export const tooltipMessage = {
  stickyContact: `${t("common.stickyContactMessage")}`,
  showSubmissionInConversationsFeed: `${t("common.showSubmissionInConversationsFeedMessage")}`,
  backButton: `${t("survey.backButtonTooltipMessage")}`,
  disableAutoNavigation: `${t("survey.disableAutoNavigationTooltipMessage")}`,
  autoNavigation: `${t("survey.autoNavigationTooltipMessage")}`,
  progressBar: `${t("survey.progressBarTooltipMessage")}`,
  disableAnimation: `${t("survey.disableAnimationTooltipMessage")}`,
  scrollToTop: `${t("survey.scrollToTopTooltipMessage")}`,
  fullScreenMode: `${t("form.fullScreenModetooltip")}`,
  enableTimezoneForm: t("form.enableTimezoneForm"),
  enableTimezoneSurvey: t("survey.enableTimezoneSurvey"),
};
export const DEFAULT_LABEL_COLOR = "188bf6";
export const DEFAULT_TEXT_COLOR = "000000";
export const PERCENTAGE_BAR_DEFAULT_TEXTCOLOR = "B2CCFF";
export const STEPS_DEFAULT_TEXTCOLOR = "00359E";
export const THEMES = [
  {
    theme: "steps",
    selectedImage: StepsSelectedImage,
    unselectedImage: StepsImage,
  },
  {
    theme: "percentageBar",
    selectedImage: PercentageBarSelectedImage,
    unselectedImage: PercentageBarImage,
  },
];
export const DEFAULT_FOOTER_SHADOW = "0 0 7px 0 rgba(50, 50, 50, 0.75)";
export const LEFT = "left";
export const RIGHT = "right";
export const LEFT_AND_RIGHT = "leftAndRight";
export const ONLY_ARROW = "onlyArrow";
export const ONLY_TEXT = "onlyText";
export const TEXT_AND_ARROW = "textAndArrow";

export const IS_FILLED = "isFilled";
export const IS_EMPTY = "isEmpty";

// Conditional logic operation keys
export const CONDITIONAL_OPERATIONS = {
  IS_FILLED,
  IS_EMPTY,
  IS_CHECKED: "isChecked",
  IS_NOT_CHECKED: "isNotChecked",
} as const;

export const colorBgVariants = {
  success: "bg-success-100",
  primary: "bg-primary-100",
  error: "bg-error-100",
  warning: "bg-warning-100",
  violet: "bg-violet-100",
};

export const colorBgHoverVariants = {
  success: "hover:bg-success-50",
  primary: "hover:bg-primary-50",
  error: "hover:bg-error-50",
  warning: "hover:bg-warning-50",
  violet: "hover:bg-violet-50",
};

export const colorTextVariants = {
  success: "text-success-600",
  primary: "text-primary-600",
  error: "text-error-600",
  warning: "text-warning-600",
  violet: "text-violet-600",
};

export const MAX_HISTORY_LENGTH = 20;

export const dateFormat = ["MM-DD-YYYY", "DD-MM-YYYY", "YYYY-MM-DD"];

export const separators = ["-", "/", "."];

export const DEFAULT_ACTIVE_TAG_BG_COLOR = "009ef426";

export const BORDER_STYLES = [
  {
    name: t("common.borderTypeList.solid"),
    key: "solid",
    icon: SquareIcon,
  },
  {
    name: t("common.borderTypeList.dotted"),
    key: "dotted",
    icon: Maximize02Icon,
  },
  {
    name: t("common.borderTypeList.dashed"),
    key: "dashed",
    icon: () => h("img", { src: GridDotBlank }),
  },
  {
    name: t("common.borderTypeList.none"),
    key: "none",
    icon: SlashCircle01Icon,
  },
];

export const FB_EVENTS = [
  { label: "AddPaymentInfo", value: "AddPaymentInfo" },
  { label: "AddToCart", value: "AddToCart" },
  { label: "AddToWishlist", value: "AddToWishlist" },
  { label: "CompleteRegistration", value: "CompleteRegistration" },
  { label: "Contact", value: "Contact" },
  { label: "CustomizeProduct", value: "CustomizeProduct" },
  { label: "Donate", value: "Donate" },
  { label: "FindLocation", value: "FindLocation" },
  { label: "InitiateCheckout", value: "InitiateCheckout" },
  { label: "Lead", value: "Lead" },
  { label: "Page View", value: "PageView" },
  { label: "Purchase", value: "Purchase" },
  { label: "Schedule", value: "Schedule" },
  { label: "Search", value: "Search" },
  { label: "StartTrial", value: "StartTrial" },
  { label: "Submit Application", value: "SubmitApplication" },
  { label: "Subscribe", value: "Subscribe" },
  { label: "ViewContent", value: "ViewContent" },
  { label: "None", value: "None" },
];
export const FULL_WIDTH_FIELDS = [
  "img",
  "submit",
  "h1",
  "html",
  "captcha",
  "large_text",
  "source",
  "file_upload",
  "terms_and_conditions",
  "payment",
  "group", // google address
];

export const CONSTANTS = {
  ONE_COLUMN: 1,
  TWO_COLUMN: 2,
  SINGLE_LINE: 3,
};

export const couponAlignment = [
  { key: "left", name: t("common.payment.coupons.left") },
  { key: "right", name: t("common.payment.coupons.right") },
  { key: "fullWidth", name: t("common.payment.coupons.fullWidth") },
];

export const FOOTER_STYLE_SURVEY = {
  theme: "steps",
  backgroundFill: "006EEEFF",
  fontFamily: "Roboto",
  fontSize: 14,
  fontWeight: 400,
  height: 50,
  enableProgressBar: false,
  stickyFooter: true,
  progressBarStyle: {
    textColor: "B2CCFF",
    borderColor: "84ADFF",
    borderWidth: 1,
    borderRadius: 12,
    completeFillColor: "84ADFF",
    inactiveFillColor: "FFFFFF00",
  },
  buttonStyle: {
    buttonType: "textAndArrow",
    position: "leftAndRight",
    fontColor: "FFFFFF",
    nextButtonBgColor: "00000012",
    backButtonBgColor: "FFFFFF00",
    submitButtonBgColor: "00000012",
    prevBtnText: "PREV",
    nextBtnText: "NEXT",
    submitBtnText: "SUBMIT",
  },
  computedStyles: null,
};

export const FOOTER_STYLE_QUIZ = {
  theme: "steps",
  backgroundFill: "FFFFFF",
  fontFamily: "Roboto",
  fontSize: 14,
  fontWeight: 600,
  height: 50,
  enableProgressBar: false,
  stickyFooter: true,
  progressBarStyle: {
    textColor: "B2CCFF",
    borderColor: "84ADFF",
    borderWidth: 1,
    borderRadius: 12,
    completeFillColor: "84ADFF",
    inactiveFillColor: "FFFFFF00",
  },
  buttonStyle: {
    buttonType: "textAndArrow",
    position: "leftAndRight",
    fontColor: "000000",
    nextButtonBgColor: "FFFFFF00",
    backButtonBgColor: "FFFFFF00",
    submitButtonBgColor: "FFFFFF00",
    prevBtnText: "PREV",
    nextBtnText: "NEXT",
    submitBtnText: "SUBMIT",
  },
  computedStyles: null,
};

export const DUPLICATE_ALLOWED_FIELDS = ["h1", "img", "html"];

export const FIELDS_ALLOWED_SAME_SLIDE = ["h1", "img", "html", "terms_and_conditions"];

export const OPTIONS_FIELD = [
  "RADIO",
  "SINGLE_OPTIONS",
  "MULTIPLE_OPTIONS",
  "CHECKBOX",
  "SCORE",
  "TEXTBOX_LIST",
];
export const CATEGORY_FIELDS = ["RADIO", "SINGLE_OPTIONS", "MULTIPLE_OPTIONS", "CHECKBOX"];

export const JUMP_TO_FIELDS = ["RADIO", "SINGLE_OPTIONS", "MULTIPLE_OPTIONS", "CHECKBOX"];

export const PRODUCT_TYPE = {
  FORM: "form",
  QUIZ: "quiz",
  SURVEY: "survey",
};

export const LABEL_ALIGNMENT = [
  {
    name: t("common.left"),
    key: "left",
    icon: LeftArrow,
  },
  {
    name: t("common.top"),
    key: "top",
    icon: TopArrow,
  },
  {
    name: t("common.right"),
    key: "right",
    icon: RightArrow,
  },
  {
    name: t("common.formDefault"),
    key: "default",
    icon: null,
  },
];

export const SHARE_TYPE = {
  EMBED_CODE: 1,
  SHARE: 2,
  EMAIL: 3,
};

export const SHARE_TYPE_LIST = [
  { id: SHARE_TYPE.EMBED_CODE, name: t("common.integratePopup.embedCode") },
  { id: SHARE_TYPE.SHARE, name: t("common.integratePopup.share.share") },
  { id: SHARE_TYPE.EMAIL, name: t("common.integratePopup.email.email") },
];

export const RATING_ELEMENTS = [
  {
    name: "star",
    icon: StarIcon,
  },
  {
    name: "heart",
    icon: HeartIcon,
  },
  {
    name: "thumb",
    icon: ThumbsUpIcon,
  },
  {
    name: "flag",
    icon: FlagIcon,
  },
  {
    name: "bulb",
    icon: BulbIcon,
  },
];

export const RATING_COUNT = [
  { label: "1", value: 1 },
  { label: "2", value: 2 },
  { label: "3", value: 3 },
  { label: "4", value: 4 },
  { label: "5", value: 5 },
  { label: "6", value: 6 },
  { label: "7", value: 7 },
  { label: "8", value: 8 },
  { label: "9", value: 9 },
  { label: "10", value: 10 },
];

export const RATING_ALIGNMENT = [
  {
    name: t("common.left"),
    key: "left",
    icon: LeftArrow,
  },
  {
    name: t("common.right"),
    key: "right",
    icon: RightArrow,
  },
  {
    name: t("common.center"),
    key: "center",
    icon: AlignVerticalCenter01Icon,
  },
];

export const RATING_CALCULATION_TYPE = [
  {
    label: t("common.rating.calculationType.absolute"),
    value: "absolute",
  },
  {
    label: t("common.rating.calculationType.percentage"),
    value: "percentage",
  },
  {
    label: t("common.rating.calculationType.fraction"),
    value: "fraction",
  },
];

export const UNIQUE_KEY_FIELD_KEYS = {
  RATING: "rat584",
};
export const MISMATCH_DATA_TYPE = {
  RATING: "RATING",
  SCORE: "SCORE",
};

export const RATING_ELEMENT_DEFAULTS = {
  color: "fbbf24",
  iconType: "star",
  count: 5,
  lowestRating: "Bad",
  highestRating: "Good",
  calculationType: "absolute",
  iconAlignment: "left",
  inactiveColor: "E5E7EB",
};
export const deviceOptions = [
  {
    key: "desktop",
    icon: () => h(Monitor04Icon, { class: "h-4 w-4" }),
  },
  {
    key: "mobile",
    icon: () => h(Phone01Icon, { class: "h-4 w-4" }),
  },
];

export const EMAIL_CAMPAIGN_TYPE = {
  BLANK: "blank",
  MARKETING: "marketing",
  TEMPLATE: "template",
};
export const carouselItems: CarouselItem[] = [
  {
    key: "1",
    src: "https://stcdn.leadconnectorhq.com/forms/img/Manage.png",
  },
  {
    key: "2",
    src: "https://stcdn.leadconnectorhq.com/forms/img/Options.png",
  },
  {
    key: "3",
    src: "https://stcdn.leadconnectorhq.com/forms/img/Category.png",
  },
];

// Button Style Constants
export const BUTTON_STYLE_CONSTANTS = {
  PADDING: "10px 18px",
  BORDER_RADIUS: "8px",
  FONT_WEIGHT: 600,
  HEIGHT: "40px",
  MIN_WIDTH: "156px",
  MARGIN_TOP: "4px",
  COLOR_SLICE_LENGTH: 6,
  DEFAULT_COLOR: "ffffff",
} as const;

// TypeScript Interfaces for Button Configuration
export interface ButtonShadowConfig {
  color: string;
  horizontal: number;
  vertical: number;
  blur: number;
  spread: number;
}

export interface ButtonPaddingConfig {
  top: number;
  bottom: number;
  left: number;
  right: number;
}

export interface ButtonThemeConfig {
  bgColor: string;
  color: string;
  subTextColor: string;
  border: number;
  borderType: string;
  borderColor: string;
  shadow?: ButtonShadowConfig;
  padding?: ButtonPaddingConfig;
  borderRadius?: number;
  fontSize?: number;
  weight?: number;
  fontFamily?: string;
  subTextFontSize?: number;
  subTextWeight?: number;
  subTextFontFamily?: string;
  align?: string;
}

export interface ButtonTheme {
  id: string;
  config: ButtonThemeConfig;
}

export interface ButtonThemeCategories {
  filled: ButtonTheme[];
  border: ButtonTheme[];
  textOnly: ButtonTheme[];
}

// Base button theme configuration
const BUTTON_BASE_CONFIG: ButtonThemeConfig = {
  bgColor: "155EEFFF",
  color: "FFFFFFFF",
  subTextColor: "FFFFFFFF",
  border: 0,
  borderType: "none",
  borderColor: "155EEFFF",
  padding: { top: 12, bottom: 12, left: 20, right: 20 },
  borderRadius: 8,
  shadow: { color: "00000014", horizontal: 0, vertical: 1, blur: 2, spread: 0 },
  fontSize: 14,
  weight: 500,
  fontFamily: "Inter",
  subTextFontSize: 12,
  subTextWeight: 400,
  subTextFontFamily: "Inter",
  align: "center",
};

export const BUTTON_THEMES: ButtonThemeCategories = {
  filled: [
    {
      id: "filled-blue",
      config: {
        bgColor: "155EEFFF",
        color: "FFFFFFFF",
        subTextColor: "FFFFFFFF",
        border: 0,
        borderType: "none",
        borderColor: "155EEFFF",
        shadow: { color: "00000014", horizontal: 0, vertical: 1, blur: 2, spread: 0 },
      },
    },
    {
      id: "filled-black",
      config: {
        bgColor: "101828FF",
        color: "FFFFFFFF",
        subTextColor: "FFFFFFFF",
        border: 0,
        borderType: "none",
        borderColor: "101828FF",
        shadow: { color: "00000014", horizontal: 0, vertical: 1, blur: 2, spread: 0 },
      },
    },
    {
      id: "filled-green",
      config: {
        bgColor: "039855FF",
        color: "FFFFFFFF",
        subTextColor: "FFFFFFFF",
        border: 0,
        borderType: "none",
        borderColor: "039855FF",
        shadow: { color: "00000014", horizontal: 0, vertical: 1, blur: 2, spread: 0 },
      },
    },
    {
      id: "filled-purple",
      config: {
        bgColor: "444CE7FF",
        color: "FFFFFFFF",
        subTextColor: "FFFFFFFF",
        border: 0,
        borderType: "none",
        borderColor: "444CE7FF",
        shadow: { color: "00000014", horizontal: 0, vertical: 1, blur: 2, spread: 0 },
      },
    },
    {
      id: "filled-violet",
      config: {
        bgColor: "7A5AF8FF",
        color: "FFFFFFFF",
        subTextColor: "FFFFFFFF",
        border: 0,
        borderType: "none",
        borderColor: "7A5AF8FF",
        shadow: { color: "00000014", horizontal: 0, vertical: 1, blur: 2, spread: 0 },
      },
    },
    {
      id: "filled-pink",
      config: {
        bgColor: "BA24D5FF",
        color: "FFFFFFFF",
        subTextColor: "FFFFFFFF",
        border: 0,
        borderType: "none",
        borderColor: "BA24D5FF",
        shadow: { color: "00000014", horizontal: 0, vertical: 1, blur: 2, spread: 0 },
      },
    },
    {
      id: "filled-light-blue",
      config: {
        bgColor: "EFF4FFFF",
        color: "004EEBFF",
        subTextColor: "004EEBFF",
        border: 0,
        borderType: "none",
        borderColor: "EFF4FFFF",
        shadow: { color: "00000014", horizontal: 0, vertical: 1, blur: 2, spread: 0 },
      },
    },
    {
      id: "filled-light-green",
      config: {
        bgColor: "ECFDF3FF",
        color: "027A48FF",
        subTextColor: "027A48FF",
        border: 0,
        borderType: "none",
        borderColor: "ECFDF3FF",
        shadow: { color: "00000014", horizontal: 0, vertical: 1, blur: 2, spread: 0 },
      },
    },
    {
      id: "filled-white",
      config: {
        bgColor: "F9FAFBFF",
        color: "101828FF",
        subTextColor: "667085FF",
        border: 0,
        borderType: "none",
        borderColor: "FFFFFFFF",
        shadow: { color: "00000014", horizontal: 0, vertical: 1, blur: 2, spread: 0 },
      },
    },
    {
      id: "filled-light-yellow",
      config: {
        bgColor: "FEFBE8FF",
        color: "A15C07FF",
        subTextColor: "A15C07FF",
        border: 0,
        borderType: "none",
        borderColor: "FEFBE8FF",
        shadow: { color: "00000014", horizontal: 0, vertical: 1, blur: 2, spread: 0 },
      },
    },
    {
      id: "filled-light-purple",
      config: {
        bgColor: "F4F3FFFF",
        color: "5925DCFF",
        subTextColor: "5925DCFF",
        border: 0,
        borderType: "none",
        borderColor: "F4F3FFFF",
        shadow: { color: "00000014", horizontal: 0, vertical: 1, blur: 2, spread: 0 },
      },
    },
    {
      id: "filled-light-pink",
      config: {
        bgColor: "FDF4FFFF",
        color: "9F1AB1FF",
        subTextColor: "9F1AB1FF",
        border: 0,
        borderType: "none",
        borderColor: "FDF4FFFF",
        shadow: { color: "00000014", horizontal: 0, vertical: 1, blur: 2, spread: 0 },
      },
    },
  ],
  border: [
    {
      id: "border-blue",
      config: {
        bgColor: "FFFFFFFF",
        color: "155EEFFF",
        subTextColor: "155EEFFF",
        border: 1,
        borderType: "solid",
        borderColor: "155EEFFF",
        shadow: { color: "00000014", horizontal: 0, vertical: 1, blur: 2, spread: 0 },
      },
    },
    {
      id: "border-black",
      config: {
        bgColor: "FFFFFFFF",
        color: "101828FF",
        subTextColor: "344054FF",
        border: 1,
        borderType: "solid",
        borderColor: "101828FF",
        shadow: { color: "00000014", horizontal: 0, vertical: 1, blur: 2, spread: 0 },
      },
    },
    {
      id: "border-green",
      config: {
        bgColor: "FFFFFFFF",
        color: "027A48FF",
        subTextColor: "027A48FF",
        border: 1,
        borderType: "solid",
        borderColor: "027A48FF",
        shadow: { color: "00000014", horizontal: 0, vertical: 1, blur: 2, spread: 0 },
      },
    },
    {
      id: "border-purple",
      config: {
        bgColor: "FFFFFFFF",
        color: "3538CDFF",
        subTextColor: "3538CDFF",
        border: 1,
        borderType: "solid",
        borderColor: "3538CDFF",
        shadow: { color: "00000014", horizontal: 0, vertical: 1, blur: 2, spread: 0 },
      },
    },
    {
      id: "border-violet",
      config: {
        bgColor: "FFFFFFFF",
        color: "5925DCFF",
        subTextColor: "5925DCFF",
        border: 1,
        borderType: "solid",
        borderColor: "5925DCFF",
        shadow: { color: "00000014", horizontal: 0, vertical: 1, blur: 2, spread: 0 },
      },
    },
    {
      id: "border-pink",
      config: {
        bgColor: "FFFFFFFF",
        color: "9F1AB1FF",
        subTextColor: "9F1AB1FF",
        border: 1,
        borderType: "solid",
        borderColor: "9F1AB1FF",
        shadow: { color: "00000014", horizontal: 0, vertical: 1, blur: 2, spread: 0 },
      },
    },
  ],
  textOnly: [
    {
      id: "text-blue",
      config: {
        bgColor: "FFFFFF00",
        color: "004EEBFF",
        subTextColor: "004EEBFF",
        border: 0,
        borderType: "none",
        borderColor: "FFFFFF00",
        shadow: { color: "00000000", horizontal: 0, vertical: 0, blur: 0, spread: 0 },
      },
    },
    {
      id: "text-black",
      config: {
        bgColor: "FFFFFF00",
        color: "475467FF",
        subTextColor: "475467FF",
        border: 0,
        borderType: "none",
        borderColor: "FFFFFF00",
        shadow: { color: "00000000", horizontal: 0, vertical: 0, blur: 0, spread: 0 },
      },
    },
    {
      id: "text-green",
      config: {
        bgColor: "FFFFFF00",
        color: "027A48FF",
        subTextColor: "027A48FF",
        border: 0,
        borderType: "none",
        borderColor: "FFFFFF00",
        shadow: { color: "00000000", horizontal: 0, vertical: 0, blur: 0, spread: 0 },
      },
    },
    {
      id: "text-purple",
      config: {
        bgColor: "FFFFFF00",
        color: "101828FF",
        subTextColor: "101828FF",
        border: 0,
        borderType: "none",
        borderColor: "FFFFFF00",
        shadow: { color: "00000000", horizontal: 0, vertical: 0, blur: 0, spread: 0 },
      },
    },
    {
      id: "text-violet",
      config: {
        bgColor: "FFFFFF00",
        color: "6927DAFF",
        subTextColor: "6927DAFF",
        border: 0,
        borderType: "none",
        borderColor: "FFFFFF00",
        shadow: { color: "00000000", horizontal: 0, vertical: 0, blur: 0, spread: 0 },
      },
    },
    {
      id: "text-red",
      config: {
        bgColor: "FFFFFF00",
        color: "B42318FF",
        subTextColor: "B42318FF",
        border: 0,
        borderType: "none",
        borderColor: "FFFFFF00",
        shadow: { color: "00000000", horizontal: 0, vertical: 0, blur: 0, spread: 0 },
      },
    },
  ],
};

export { BUTTON_BASE_CONFIG };

// Default color swatches for color picker
export const colors = [
  {
    label: "Primary",
    value: "#37CA37FF",
  },
  {
    label: "Secondary",
    value: "#188BF6FF",
  },
  {
    label: "White",
    value: "#FFFFFFFF",
  },
  {
    label: "Gray",
    value: "#CBD5E0FF",
  },
  {
    label: "Black",
    value: "#000000",
  },
  {
    label: "Red",
    value: "#E93D3DFF",
  },
  {
    label: "Orange",
    value: "#F6AD55FF",
  },
  {
    label: "Yellow",
    value: "#FAF089FF",
  },
  {
    label: "Green",
    value: "#9AE6B4FF",
  },
  {
    label: "Teal",
    value: "#81E6D9FF",
  },
  {
    label: "Malibu",
    value: "#63B3EDFF",
  },
  {
    label: "Indigo",
    value: "#757BBDFF",
  },
  {
    label: "Purple",
    value: "#D6BCFAFF",
  },
  {
    label: "Pink",
    value: "#FBB6CEFF",
  },
  {
    label: "Overlay",
    value: "#00000050",
  },
];

export const defaultColorsArray = colors.map((item) => {
  return {
    value: item.value,
    value8: item.value,
    alpha: 100,
    label: item.label,
    labelValue: item.label,
  };
});

export enum GlobalSettingsEvents {
  OPEN_GLOBAL_SETTINGS = "open-global-settings",
  GLOBAL_SETTINGS_CLOSED = "global-settings-closed",
}

// Contact Association Modal Constants
export const ASSOCIATION_CONSTANTS = {
  CACHE_EXPIRY_MINUTES: 5,
  CACHE_EXPIRY_MS: 5 * 60 * 1000, // 5 minutes in milliseconds
  DEFAULT_SLIDE_INDEX: 0,
  UNDERSCORE_REGEX: /_/g,
  SPACE_SEPARATOR: " ",
  CONTACT_OBJECT_TYPE: "contact",
} as const;

// Image Layout Constants
export const IMAGE_LAYOUT = {
  // Desktop layouts
  TOP_FIXED: "topFixed",
  LEFT_CENTER: "leftCenter",
  RIGHT_CENTER: "rightCenter",
  LEFT_FIXED: "leftFixed",
  RIGHT_FIXED: "rightFixed",
  BACKGROUND: "background",
  // Mobile layouts
  HEADER: "header",
} as const;

// Survey Mode Constants
export const SURVEY_MODE = {
  SURVEY_DEFAULT: "surveyDefault",
  INDEPENDENT: "independent",
} as const;

// Image Layout Options Functions
export interface ImageLayoutOption {
  value: string;
  label: string;
  icon: any;
}

/**
 * Get desktop image layout options
 * @param t - Translation function
 * @returns Array of desktop layout options
 */
export const getDesktopLayoutOptions = (t: (key: string) => string): ImageLayoutOption[] => [
  {
    value: IMAGE_LAYOUT.TOP_FIXED,
    label: t("common.style.imageLayout.desktop.topFixed"),
    icon: TopFixedIcon,
  },
  {
    value: IMAGE_LAYOUT.LEFT_CENTER,
    label: t("common.style.imageLayout.desktop.leftCenter"),
    icon: LeftCenterIcon,
  },
  {
    value: IMAGE_LAYOUT.RIGHT_CENTER,
    label: t("common.style.imageLayout.desktop.rightCenter"),
    icon: RightCenterIcon,
  },
  {
    value: IMAGE_LAYOUT.LEFT_FIXED,
    label: t("common.style.imageLayout.desktop.leftFixed"),
    icon: LeftFixedIcon,
  },
  {
    value: IMAGE_LAYOUT.RIGHT_FIXED,
    label: t("common.style.imageLayout.desktop.rightFixed"),
    icon: RightFixedIcon,
  },
  {
    value: IMAGE_LAYOUT.BACKGROUND,
    label: t("common.style.imageLayout.desktop.background"),
    icon: BackgroundIcon,
  },
];

/**
 * Get mobile image layout options
 * @param t - Translation function
 * @returns Array of mobile layout options
 */
export const getMobileLayoutOptions = (t: (key: string) => string): ImageLayoutOption[] => [
  {
    value: IMAGE_LAYOUT.HEADER,
    label: t("common.style.imageLayout.mobile.header"),
    icon: TopFixedIcon,
  },
  {
    value: IMAGE_LAYOUT.BACKGROUND,
    label: t("common.style.imageLayout.mobile.background"),
    icon: BackgroundIcon,
  },
];
export const TERMS_AND_CONDITIONS_LABEL = {
  PHONE:
    "By checking this box, I consent to receive non-marketing text messages from <b>[BUSINESS NAME]</b> about <b>[USE_CASE_FROM_CAMPAIGN_DESCRIPTION]</b>. Message frequency varies, message & data rates may apply. Text HELP for assistance, reply STOP to opt out.",
  PROMOTIONAL:
    "By checking this box, I consent to receive marketing and promotional messages including special offers, discounts, new product updates among others.from <b>[BUSINESS NAME]</b> at the phone number provided. Frequency may vary. Message & data rates may apply. Text HELP for assistance, reply STOP to opt out.",
};
